<template>
  <span
    v-if="useSvgLayout"
    class="ux-icon ux-icon-svg"
    :class="modifierClasses"
  >
    <slot />
  </span>
  <i v-else class="ux-icon fa" :class="iconClasses" />
</template>
<script>
export default {
  props: {
    icon: {
      type: [Object, String],
    },
    spin: {
      type: Boolean,
    },
    left: {
      type: Boolean,
    },
    right: {
      type: Boolean,
    },
    fixed: {
      type: Boolean,
    },
  },
  computed: {
    useSvgLayout() {
      // Use the slot/SVG-friendly span layout when:
      //   - the default slot has content (e.g. <ux-icon><svg .../></ux-icon>), OR
      //   - no `icon` prop is provided (so consumers using v-html to inject an
      //     SVG string get the same sizing/alignment as a slotted SVG).
      return !!this.$slots.default || !this.icon;
    },
    modifierClasses() {
      var array = [];

      if (this.spin) {
        array.push(`fa-spin`);
      }
      if (this.left) {
        array.push("ux-icon-left");
      }
      if (this.right) {
        array.push("ux-icon-right");
      }
      if (this.fixed) {
        array.push("ux-icon-fixed");
      }

      return array;
    },
    iconClasses() {
      return [this.icon, ...this.modifierClasses];
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-icon {
  &.ux-icon-left {
    margin-right: 0.4em;
  }

  &.ux-icon-right {
    margin-left: 0.4em;
  }

  &.ux-icon-fixed {
    width: 1em;
    text-align: center;
  }
}

// Slot variant — anything passed as default-slot content (typically an inline
// SVG) is sized to match the surrounding text and aligned with the baseline,
// so <ux-icon><svg .../></ux-icon> behaves like a font-awesome icon.
.ux-icon-svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;
  vertical-align: -0.125em;

  :deep(svg) {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
